exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.kt-quick-search.kt-quick-search--has-result .kt-quick-search__wrapper[data-v-71878d66] {\n    overflow-y: auto !important;\n}\n", ""]);

// exports
